module.exports = __webpack_public_path__ + "img/1F1FF-1F1F2.7e58048a.svg";